import React from "react";

import Accordion from "@/app/shared-components/accordion/accordion";
import RichText from "@/app/shared-components/rich-text/rich-text";

import Styles from "./pmi-accordion-content.module.css";
import { usePMIContext } from "../../../provider/private-medical-insurance.provider";

function PMIDrawer() {
  const { cmsData } = usePMIContext();
  const { drawerAccordionText, drawerAccordionTitle } =
    cmsData.personalMedicalQuestionArea[0];
  return (
    <div>
      <Accordion
        title={drawerAccordionTitle}
        className="w-full"
        content={<RichText richText={drawerAccordionText} />}
        buttonClassName="text-l text-text-title leading-[27.5px] font-header-font font-normal text-left"
        contentClassName={Styles.pmiAccordionContent}
      />
    </div>
  );
}

export default PMIDrawer;
